import { Base } from 'src/api/Base'

export class BudgetAPI extends Base {
  static get entity() {
    return 'budget'
  }

  static async getCopyDirections() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/copy-directions`, { params })

    return data
  }

  static async copyBudget({
    fromDealerShipIds,
    fromYear,
    fromMonth,
    toDealerShipId,
    toYear,
    toMonth,
    direction,
    productId,
    productCategoryId,
    forceToCopy,
  }) {
    const params = {
      dealerGroupId: this.datepicker.dealerGroupId,
    }
    const body = {
      fromDealerShipIds: fromDealerShipIds.join(','),
      fromYear,
      fromMonth,
      toDealerShipId,
      toYear,
      toMonth,
      direction,
      productId,
      productCategoryId,
      forceToCopy,
    }

    const { data } = await this.request({
      shouldCancelOnGet: false,
      shouldCancelOnRoute: false,
    }).post(`/${this.entity}/copy`, body, {
      params,
    })

    return data
  }

  static async clear({ dealerShipIds }) {
    const params = {
      ...this.datepicker,
    }
    const body = {
      dealerShipIds,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/clear`, body, {
      params,
    })

    return data
  }

  static async getList({ month = this.datepicker.month, year = this.datepicker.year } = {}) {
    const params = {
      ...this.datepicker,
      month,
      year,
    }
    const { data } = await this.request().get(`/${this.entity}/list`, {
      params,
    })

    return data
  }

  static async getRtb() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/rtb`, {
      params,
    })

    return data
  }

  static async getStats() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/stats`, {
      params,
    })

    return data
  }

  static async getTotal() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/total`, {
      params,
    })

    return data
  }

  static async copyActualToPlanned() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/copy-actual-to-planned`, {}, { params })

    return data
  }

  static async copyPlannedToActual() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/copy-planned-to-actual`, {}, { params })

    return data
  }

  static async update({ budgetTarget }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      budgetTarget,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update`, body, { params })

    return data
  }

  static async getCampaigns() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/campaigns`, {
      params,
    })

    return data
  }

  static async deleteCampaign({ productCategoryId, productId, campaign }) {
    const { dealerGroupId, dealerShipId, month, year } = this.datepicker

    const params = {
      dealerGroupId,
      month,
      year,
      dealerships: dealerShipId,
    }

    const body = {
      productCategoryId,
      productId,
      campaign,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete-campaign`, body, { params })

    return data
  }

  static async deleteCategory({ productCategoryId }) {
    const { dealerGroupId, dealerShipId, month, year } = this.datepicker

    const params = {
      dealerGroupId,
      month,
      year,
      dealerships: dealerShipId,
    }

    const body = {
      productCategoryId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete-category`, body, { params })

    return data
  }

  static async deleteProduct({ productId, productCategoryId }) {
    const { dealerGroupId, dealerShipId, month, year } = this.datepicker

    const params = {
      dealerGroupId,
      month,
      year,
      dealerships: dealerShipId,
    }

    const body = {
      productId,
      productCategoryId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/delete-product`, body, { params })

    return data
  }

  static async export(_params) {
    const params = {
      ..._params,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).get(`/${this.entity}/export`, { params })

    return data
  }
}
